<template>
    <div class="aqui">
        <Header class="headertag" :navSecao="navSecao" :idUsu="idUsuario" v-if="user"/>
        <router-view class="content" />
        <Footer class="footertag" v-if="user"/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import {userKey, userKeyT} from "../global/utils"
import Header from '../components/_include/Cabecalho'
import Footer from '../components/_include/Rodape'
export default {

    name: 'App',
    computed: mapState(['isMenuVisible','api_url','data_content','user','isEditing','client','navSecao' ]),
    data: () => ({
        validationToken: true,
        isAdmin: true,
        idUsuario: null,
    }), 
    components:{Header,Footer},
    mounted() {
        //this.$vs.loading()
    },
    methods: {
    async validateToken(){
      this.validationToken = true
      const json = localStorage.getItem(userKey)
      const userData = JSON.parse(json)
      if(!userData)
      {
          this.$store.commit('setUser',null)
          this.validationToken = false
          this.$router.push({name: "auth"})
          return
      }
      const res = await axios.post('listausuarios/validate',userData)
      if(res.data){
          this.$store.commit('setUser', localStorage.getItem(userKey))
          localStorage.setItem(userKeyT,userData.tokenAuth)
          this.idUsuario = userData.userId
      }else{
        localStorage.removeItem(userKey)
        this.$router.push({name: "auth"})
      }
      this.validationToken = false
    },
    convertToken(token) {
          var base64Url = token.split('.')[1];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));
      
          return JSON.parse(jsonPayload);
      }
        
  },
  created() {
    this.validateToken()
  },  
}
</script>

<style lang="scss" scoped>
    .aqui{
        display: flex;
        flex-wrap: wrap;
        min-height: 100vh;
        .headertag,.content,.footertag{
            flex: 1 0 100%;
        }
    }
    .content{
        min-height: calc(100vh - 208px) ;
    }
    .footertag{
        height: 55px;
    }
    .headertag{
        height: 150px;
    }
</style>           